module.exports = __webpack_public_path__ + "static/media/images-solid.24f88d43.svg";